// extracted by mini-css-extract-plugin
module.exports = {"roomCard":"AdvancedOptionsRateDistributionTab_roomCard__2Xihp","scrollBarStyle":"AdvancedOptionsRateDistributionTab_scrollBarStyle__Ia1US"};